// config.js
export const VERSION = 'V-0.25';